import { Injectable } from "@angular/core";
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Subject } from "rxjs";
import { CustomValidatorService } from "../../../../Shared/custom-validator.service";
import { lengthValidator } from "../../../../Shared/length-validator.service";

@Injectable({
  providedIn: "root",
})
export class FormService {
  private form: FormGroup;
  step: number = 0;

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      businessDetails: this.fb.group({
        business_name: ["", Validators.required],
        companyName: [""],
        email: ["", [Validators.required, Validators.email]],
        phone: ["", [Validators.required, this.phoneNumberValidator2]],
        rcNumber: ["", [Validators.required]],
        tin: [""],
        entityType:[""],
        regDate: [""],
        password: [
          "",
          [
            Validators.required,
            Validators.pattern(
              /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+])[A-Za-z0-9!@#$%^&*()_+]{8,}$/
            ),
          ],
        ],
        confirm_password: [
          "",
          [
            Validators.required,
            Validators.pattern(
              /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+])[A-Za-z0-9!@#$%^&*()_+]{8,}$/
            ),
          ],
        ],
      }),
      businessInformation: this.fb.group({
        businessCategory: ["", Validators.required],
        numberOfEmployees: [
          "",
          [Validators.required, CustomValidatorService.asyncNumericValidator],
        ],
        numberOfBranches: [
          "",
          [Validators.required, CustomValidatorService.asyncNumericValidator],
        ],
        webAddress: ["", [lengthValidator(5, 20)]],
        dateOfCommencement: [""],
        businessAddress: ["", [Validators.required, lengthValidator(2, 50)]],
        businessState: ["", [Validators.required]],
        businessLga: ["", Validators.required],
        businessArea: [""],
        businessContactFirstName: [
          "",
          [Validators.required, lengthValidator(5, 20)],
        ],
        businessContactLastName: [
          "",
          [Validators.required, lengthValidator(5, 20)],
        ],
        businessContactEmail: ["", [Validators.required, Validators.email]],
        businessContactPhoneNumber: [
          "",
          [Validators.required, this.phoneNumberValidator],
        ],
        businessContactPosition: [
          "",
          [Validators.required, lengthValidator(2, 20)],
        ],
        businessContactAddress: ["", [lengthValidator(2, 50)]],
        isBusinessAddressRented: ["", Validators.required],
        landLordName: ["", [lengthValidator(5, 20)]],
        rcNumber: [""],
        landLordPhoneNumber: ["", [this.phoneNumberValidator]],
        landLordAddress: ["", [lengthValidator(2, 50)]],
        registeredWithCac: [""],
        dateOfIncorporation: [""],
        businessType: [""],
        solelyOnline: ["", Validators.required],
        hasVehicle: ["", Validators.required],
        vehicleCount: ["", [CustomValidatorService.asyncNumericValidator]],
        hasCorporateProperty: ["", Validators.required],
        corporatePropertyCount: [
          "",
          [CustomValidatorService.asyncNumericValidator],
        ],
        hasCorporateAsset: ["", Validators.required],
        corporateAssetCount: [
          "",
          [CustomValidatorService.asyncNumericValidator],
        ],
        jtbTin: ["", [CustomValidatorService.asyncNumericValidator]],
      }),
    });
  }

  getForm(): FormGroup {
    return this.form;
  }

  get businessDetailsGroup() {
    return this.form.get("businessDetails") as FormGroup;
  }
  get businessInformationGroup() {
    return this.form.get("businessInformation") as FormGroup;
  }

  getStep(): number {
    return this.step;
  }

  nextStep() {
    this.step++;
  }

  private messageSource = new Subject<number>();
  message$ = this.messageSource.asObservable();

  sendMessage(message: number) {
    this.messageSource.next(message);
  }

  phoneNumberValidator2(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    const phoneNumberPattern = /^[0-9]{10}$/;
    if (control.value && !phoneNumberPattern.test(control.value)) {
      return { invalidPhoneNumber: true };
    }
    return null;
  }
  phoneNumberValidator(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    const phoneNumberPattern = /^[0-9]{11}$/;
    if (control.value && !phoneNumberPattern.test(control.value)) {
      return { invalidPhoneNumber: true };
    }
    return null;
  }
}
